<template>
  <b-modal
    id="school-employee-away-modal"
    size="lg"
    ok-only
    :title="$t('AWAY.INDIVIDUAL')"
  >
    <SchoolEmployeeIndividualLeaveTable :leaves="aways" :is-busy="isBusy">
    </SchoolEmployeeIndividualLeaveTable>

    <div class="d-flex justify-content-end" v-if="aways.length">
      <b-pagination
        pills
        size="lg"
        class="pt-5"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        @change="$emit('page-change', $event)"
      ></b-pagination>
    </div>
  </b-modal>
</template>

<script>
import SchoolEmployeeIndividualLeaveTable from "@/modules/school/components/management/attendance/SchoolEmployeeIndividualLeaveTable";

export default {
  name: "SchoolEmployeeIndividualAwayModal",
  components: { SchoolEmployeeIndividualLeaveTable },
  props: {
    aways: {
      type: Array,
      required: true,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    pagination: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped></style>
